<template>
  <v-dialog v-model="show" width="786px" persistent>
    <!-- <template v-slot:activator="{ on }"> </template> -->
    <div class="modal">
      <v-card flat :loading="status_action === 'loading'">
        <v-row>
          <div class="icon-modal table-cell">
            <v-layout class="delete-warning-icon">
              <v-flex>
                <img :src="require('@/assets/img/warning.svg')" alt=""/>
              </v-flex>
            </v-layout>
          </div>
          <v-col class="table-cell modal-content">
            <div class="d-flex justify-space-between">
              <h6 class="modal-title mb-5" style="visibility: hidden">Delete ALL</h6>
            </div>

            <p>Previous Data has been deleted, please login to your new permission level</p>

            <div class="mt-10 mb-10 buttons d-flex">
              <v-btn
                  class="mt-5 btn-azul few"
                  rounded
                  depressed
                  @click="hide"
                  :loading="status_action === 'loading'"
                  :disabled="status_action === 'loading'"
              >OK
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    props: ['show', 'hide'],
    data: () => ({
      image: require("@/assets/logo.svg")
    }),
    computed: {
      ...mapState({
        status_action: state => state.Users_list.status_action,
      })
    },
    components: {},
    methods: {
      close: function () {
        this.hide();
      }
    },
  };
</script>
